/**
 * Constants for combineGems (see BUGS/design_combine.md).
 * Pure data — no imports, no behaviour.
 *
 * Case numbers map to combineGems (commit 2):
 *   Case 1: same type + same level → L+1, no mods.
 *   Case 2: different type, same level → L+1, dual-type with penalty to both effects.
 *   Case 3: different level → apex keeps level, gains mods; lower gem consumed.
 */

/** Case 2: multiplier applied to chance AND magnitude of BOTH effects of a dual-type gem. */
export const DUAL_EFFECT_PENALTY = 0.7;

/** Case 3 apex mutation (per merge): damage multiplier stacked onto apex. >1 = stronger. */
export const APEX_DMG_MULT = 1.05;

/** Case 3 apex mutation (per merge): fire-rate multiplier. <1 = faster (shorter interval). */
export const APEX_FIRE_RATE_MULT = 0.97;

/** Case 3 apex mutation (per merge): penalty to primary (T1) effect. <1 = weaker T1. */
export const APEX_PRIMARY_PENALTY = 0.95;

/** Case 3: fixed magnitude multiplier on secondary (T2) effect when it procs. */
export const APEX_SECONDARY_MAGNITUDE = 0.5;

/** Case 3: base chance for T2 to proc; final chance = base × (L_low / L_high). */
export const APEX_SECONDARY_PROC_BASE = 0.08;

/** Maximum gem level; case 1/2 reject when result would exceed this. */
export const MAX_GEM_LEVEL = 9;
